var _path, _path2, _path3, _path4, _g, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepsSidebarCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8029_2940)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8029_2940",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8029_2940)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8029_2940",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H4C1.79086 0 0 1.79086 0 4V20C0 22.2091 1.79086 24 4 24H20C22.2091 24 24 22.2091 24 20V4C24 1.79086 22.2091 0 20 0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8029_2940)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H4C1.79086 0 0 1.79086 0 4V20C0 22.2091 1.79086 24 4 24H20C22.2091 24 24 22.2091 24 20V4C24 1.79086 22.2091 0 20 0Z",
    fill: "url(#paint0_linear_8029_2940)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_8029_2940",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_8029_2940)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0H4C1.79086 0 0 1.79086 0 4V20C0 22.2092 1.79086 24 4 24H20C22.2092 24 24 22.2092 24 20V4C24 1.79086 22.2092 0 20 0Z",
    fill: "url(#paint1_linear_8029_2940)"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 9.38997V14.2784C6 15.1475 6.21 15.8708 6.6125 16.425C6.78167 16.67 6.9975 16.8858 7.2425 17.055C7.72084 17.405 8.3275 17.6091 9.045 17.6558V6.01831C7.13167 6.14081 6 7.38331 6 9.38997Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0546 7.2425C16.8854 6.9975 16.6696 6.78166 16.4246 6.6125C15.8704 6.21 15.1471 6 14.2779 6H9.92041V17.6667H14.2779C16.4012 17.6667 17.6671 16.4009 17.6671 14.2775V9.38916C17.6671 8.52 17.4571 7.79666 17.0546 7.2425ZM13.8754 13.0175C14.0446 13.1867 14.0446 13.4667 13.8754 13.6359C13.7879 13.7234 13.6771 13.7642 13.5662 13.7642C13.4554 13.7642 13.3446 13.7234 13.2571 13.6359L11.7637 12.1425C11.5946 11.9734 11.5946 11.6934 11.7637 11.5242L13.2571 10.0309C13.4262 9.86167 13.7062 9.86167 13.8754 10.0309C14.0446 10.2 14.0446 10.48 13.8754 10.6492L12.6971 11.8334L13.8754 13.0175Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8029_2940",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8029_2940",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8029_2940"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepsSidebarCollapse);
export default __webpack_public_path__ + "static/media/StepsSidebarCollapse.7bd6ca1ab12f18d512d79cdb7b369796.svg";
export { ForwardRef as ReactComponent };